// Angular
import {
    AfterViewInit, ChangeDetectorRef, Component,
    OnDestroy,
    OnInit,
    Input,Output,EventEmitter
} from "@angular/core"
import { MatSnackBar } from "@angular/material"
import { MatDialog } from "@angular/material/dialog"
import { ActivatedRoute, NavigationEnd, Router,Params } from '@angular/router'
import _ from 'lodash'
// RxJS
import { of, Subscription } from 'rxjs'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
// Layout
import { SubheaderService } from '../../../../../core/_base/layout'
import { Breadcrumb } from '../../../../../core/_base/layout/services/subheader.service'
import { PageConfigService } from '../../../../../core/_base/layout/services/page-config.service'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { ConsultationService,AppService, DialogService, DocumentService,
 FormulaireService, StateService, UtilitaryService
 ,DossierService } from '../../../../../services'
import { FoyerActionsDialog } from '../../../content/actions/foyer-actions-dialog/foyer-actions-dialog.component'
import { SuiviActionsDialog } from '../../../content/actions/suivi-actions-dialog/suivi-actions-dialog.component'
import { VisiteActionsDialog } from '../../../content/actions/visite-actions-dialog/visite-actions-dialog.component'
import { InstructionActionsDialog } from '../../../content/actions/instruction-actions-dialog/instruction-actions-dialog.component'


import { AccesComponent } from '../../dialogs/acces-dialog/acces.component'
import { ChoiceCourrierComponent } from "../../dialogs/choice-courrier-dialog/choice-courrier.component"
import { ConfirmComponent } from '../../dialogs/confirm-dialog/confirm.component'
import { CourrierDialog } from '../../dialogs/courrier-dialog/courrier-dialog.component'
import { DoublonComponent } from '../../dialogs/doublon-dialog/doublon.component'
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component'

import { CreateConsultationDialogComponent } from "../../../content/actions/create-consultation-dialog/create-consultation-dialog.component"

const KEY = "quickmenu"

@Component({
    selector: "atyl-quickmenu",
    templateUrl: "./quickmenu.component.html",
    styleUrls: ["./quickmenu.component.scss"],
})
/*
@Stringable({
    path: "views/partials/layout/subheader/subheader3",
    key: KEY,
})
*/
export class QuickMenuComponent implements OnInit {
    // constantes
    private TYPE_ACTION = 0;
    private TYPE_FORM = 1;
    
    @Output() onActionClosed = new EventEmitter<any>();
    
    @Input() tiers: any
    private dossier: any;
    // Public properties
    droits: any = [];
    userDroits: any = [];
    user: any
    today: number = Date.now();
    title: string = "";
    desc: string = "";
    breadcrumbs: Breadcrumb[] = [];
    colorization: string = "";
    quickmenu: any[] = [];
    etats: any[] = [];
    url: string = "";
    id: string = "";
    currentState: any

    demande: any
    
    dossierWeb: any
    getCourrierFunc: any
    getImpressionFunc: any
    returnToDossierFunc: any
    createInstructionCompFunc: any
    private creationForm: any
    creationCourrier: any
    addDocument: any
    creationFoyer: any
    creationFormDossierFunc: any
    creationFormMAMDossierFunc: any
    goToURL: any
    creationInstruction: any
    archiveDossier: any
    doublonDossier: any
    showAcces: any
    labelSub: any = "Actions";
    // new variables
    formulaires: any[] = [];
  //  @StringableValues(KEY)
    strings: any
    // Private properties
	
	refreshDoosier:any=null;
	
    private subscriptions: Subscription[] = [];
    /**
     * Component constructor
     *
     * @param subheaderService: SubheaderService
     */
    constructor(
        private activatedRoute: ActivatedRoute,
        public subheaderService: SubheaderService,
        private router: Router,
        private appService: AppService,
        private stateService: StateService,
        public dialog: MatDialog,
        private cdf: ChangeDetectorRef,
        private utilities: UtilitaryService,
        private snackBar: MatSnackBar,
        private formulaireService: FormulaireService,
        private documentService: DocumentService,
        private dialogService: DialogService,
        private consultationService: ConsultationService,
        private  pageConfigService: PageConfigService,
        private  dossierService: DossierService
    ) { }
    ngOnInit() {
		console.log("QuickMenuComponent init",this.tiers.dossierID);
		

        
        
		

       
       
        this.stateService.droitsApp.subscribe((droits) => {
            if (droits === Object(droits)) this.droits = [droits]
            else this.droits = droits
        })

        this.stateService.user.subscribe((user) => {
            if (user.droits === Object(user.droits))
                this.userDroits = [user.droits]
            else this.userDroits = user.droits
            this.user = user
        })
        
    }

	loadMenu() {
			
		if (!this.refreshDoosier)
			this.refreshDoosier=this.dossierService.get(this.tiers.dossierID).subscribe((dossier: JSONRpcResponse) => {
				           
				              this.dossier=dossier.result;
				               this.labelSub = "Actions"
				            this.showAcces = () => {
				                this.displayAcces()
				            }
				            
				            this.stateService.pages.subscribe((pages) => {
					            let routeConfig = ""
					            console.log("QuickMenuComponent menu pages",pages,this.dossier)
					            let _params={
									
								}
					            if (this.dossier && this.dossier.tiers)
					            	_params["type"]= this.dossier.tiers.type;
							     if (this.dossier)
					            	_params["id"]= this.dossier.id;
									
					            
					             routeConfig="dossier/:type/:id";
					             this.handelAction(pages, routeConfig,_params)
					            
					        })
				            
				 })
				
				
	}
	
	
	ngOnDestroy() {
		console.log("QuickMenuComponent destroy",this.refreshDoosier);
		if (this.refreshDoosier)
			this.refreshDoosier.unsubscribe();
	    
	  }

    getCourrier(iddemande: string, codeform: string): void {
        this.dialogService.open(CourrierDialog, {
            data: {
                typeDemande: this.demande,
                state: this.currentState,
            },
            height: "60vh",
            width: "30vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result: any) => {
            if (result) {
				
				 if (result!=undefined && result
	                && result.ziFile!=undefined 
	                && result.ziFile.url!=undefined 
	                 && result.ziFile.url
	                ) {
						window.open(result.zipFile.url,' _blank');
					}
				
			 }

        })
    }

    getChoiceCourrier(iddemande: string, codeform: string): void {
        const dialogRef=this.dialogService.open(ChoiceCourrierComponent, {
            data: {
                typeDemande: this.demande,
                state: this.currentState,
                dossier: this.dossier
            },
            width: "30vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
        
        const sub = dialogRef.componentInstance.onFormClosed.subscribe((result: any) => {
            console.log("QuickmenuComponent ChoiceCourrierComponent",result);
             if (result!=undefined && result
	                && result.zipFile!=undefined 
	                && result.zipFile.url!=undefined 
	               && result.zipFile.url
	                ) {
						window.open(result.zipFile.url,' _blank');
				}
            
            let _refresh={
							type: "courrier",
							daossier: this.dossier,
							data: result
						};
	                   
	        this.stateService.updateRefresh(_refresh)
	    });
        
    }




    getImpression(code: string, iddemande: string, formId: string): void {
        this.appService
            .getImpression(iddemande, code, formId)
            .then((impression) => {
                window.open(impression.result[0].url, "_blank")
            })
    }
    changeState(idTransition: string, labelTransition): void {
        of(
            window.confirm(
                "Voulez-vous changer l'état de la demande vers " +
                labelTransition
            )
        ).subscribe((bool) => {
            if (bool) {
                this.appService
                    .changeEtatDemande(this.demande.ID, idTransition)
                    .then((result) => {
                        this.router.navigate([
                            "/home/assistmat/" + this.demande.dossier.ID,
                        ])
                    })
            }
        })
    }
    loadForm(
        typeDemande: string,
        typeForm: string,
        idDemande: string,
        etat: string
    ): void {
        this.router.navigate([
            "/home/formulaire/" +
            typeDemande +
            "/" +
            typeForm +
            "/" +
            idDemande +
            "/" +
            etat,
        ])
    }
    returnToDossier() {
        let id = this.demande.dossier.ID
        if (this.demande.dossier.tiers.type == "ASSMAT") {
            this.stateService.updateDemande("")
            this.router.navigate(["home/assistmat" + "/" + id])
        }
    }
   
    createInstructionOld(type: string, options?: any): void {
        this.appService.getNewInstruction(type, options).subscribe((res: JSONRpcResponse) => {
            if (!this.dossier.instructions) this.dossier.instructions = []
            this.appService
                .createNewInstruction(
                    type,
                    this.dossier.ID,
                    res.result,
                    options
                )
                .subscribe((resCreate: JSONRpcResponse) => {
                    this.dossier.instructions.unshift(resCreate.result)
                    this.stateService.updateDossier(this.dossier)
                    if (options.index_tab) {
                        this.stateService.updateRefresh(options.index_tab)
                        this.stateService.selectNewCreatedInstruction(
                            resCreate.result
                        )
                    } else {
                        this.stateService.updateRefresh(2)
                        this.stateService.selectNewCreatedInstruction(
                            resCreate.result
                        )
                    }
                })
        })
    }
    archivateDossier(retour): void {
        this.appService.archivateDossier(this.dossier.ID).subscribe((res: JSONRpcResponse) => {
            this.router.navigate(["/home/" + retour])
        })
    }
    displayAcces(): void {
        this.dialogService.open(AccesComponent, {
            data: {
                id: this.dossier ? this.dossier.ID : 0,
                email: this.dossier.access ? this.dossier.access.email : "",
                email_valid: this.dossier.access
                    ? this.dossier.access.email_valid
                    : false,
                password: this.dossier.access
                    ? this.dossier.access.passe
                    : false,
            },
            draggable: true,
            resizable: true
        }, (result: any) => {
            if (result) {
                this.utilities.log(result)
            }
        })

    }
    displayDoublon(): void {
        this.dialogService.open(DoublonComponent, {
            data: {
                id: this.dossierWeb ? this.dossierWeb.tiers.ID : 0,
            },
            height: "80vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result) => {
            if (result) {
                this.utilities.log(result)
                this.snackBar.open("Changement effectué")
                this.router.navigate(["/home/webamat"])
            }
        })

    }
    getFormulaire(button: any, page: any): void {
	    console.log("quickmenu getFormulaire",this.dossier )
        this.dialogService.open(
            FormDialogFormulaireWithSFComponent,
            {
                data: {
                    idAForm: button.IdForm,
                    dossier: this.dossier ? this.dossier : "",                    
                    create: true,
                    closeWhenValidate: true,
                    action: button,
                    v3: true,
                },
                height: "90vh",
                width: "90vw",
                draggable: true,
                resizable: true,
                minimizable: true,
                maximizable: true,
            }, (result: any) => {
                if (result.result) {
                    this.utilities.log("subhearder getFormulaire", result.result,page)
                   
                 	let _refresh={
						type: "formulaire",
						dossier: this.dossier,
						data:result.result
					};
                   
                    this.onActionClosed.emit(_refresh)
	                    
                    if (page.redirect!=undefined
                     && result.result.ID!=undefined) {
                        let _ops:any= {}
						
                        this.formulaireService
                        	.get(result.result.ID,_ops)
                        	.subscribe((dmform: JSONRpcResponse) => {
				              console.log("formulaire",dmform);
				              
				              if (dmform.result.demande!=undefined
				              && dmform.result.demande.dossier!=undefined
				              && dmform.result.demande.dossier.tiers!=undefined
				              && dmform.result.demande.dossier.tiers.type!=undefined
				               && dmform.result.demande.dossier.tiers.dossierID!=undefined
				              ) {
								let route:string="/home/"+page.redirect;
								route=route.replace(":type",dmform.result.demande.dossier.tiers.type);
					            route=route.replace(":id",dmform.result.demande.dossier.tiers.dossierID);
								console.log("formulaire route",route)
									 this.router.navigate([
				                            route
				                        ])
					
					
								}
				            
				            /*
                        this.router.navigate([
                            "/home/" +
                            page.redirect +
                            "/" +
                            result.result.demande.dossier.ID,
                        ])
                        */
				
				        })
                  }      
                }
            })
    }
    getDocument(id: string, page: any): void {
        this.dialogService.open(UploadFileDialogComponent, {
            data: {
                formulaires: this.formulaires,
                slider: {
                    enabled: true,
                    dossier: this.dossier,
                    components: {
                        formulaires: true,
                        interventions: true,
                    }

                }
            },
            height: "80vh",
            width: "45vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result: any) => {
            if (result != undefined && result != "") {
                /* let document: any= {
                     demandeid: 0,
                     value: result.selectedDocument.value,
                     status:  result.currentEtat,
                     
                   };
                  */
                let document: any = {
                    ID: 0,
                    demandeid: 0,
                    document: result.selectedDocument.document,
                    value: result.selectedDocument.value,
                    desciption: null,
                    status: result.currentEtat,
                    parameter: result.selectedDocument.parameter
                }
                document.value.parameter = result.selectedDocument.parameter
                /*
                
                result.selectedDocument.value;
                 document.status= result.currentEtat;
                 document.demandeid= 0;
                 document.document= result.selectedDocument.document;
                 document.value=result.selectedDocument.value;
                 */
                // document["demandeid"]=0;
                /* document]value = result.selectedDocument.value;
                 document.value.parameter = result.selectedDocument.parameter;
                 */
                if (result.selectedDocument.description)
                    document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;
                //  document.parameter=result.selectedDocument.parameter;

                //  document.value.archive = JSON.parse(result.archive);
                // document.status = result.currentEtat;
                if (result.selectedDocument.demandeID) {
                    document.demandeid = result.selectedDocument.demandeID;
                }

                this.documentService.setDocumentByInstruction(
                    document.demandeid, document, this.dossier.ID).subscribe((res: JSONRpcResponse) => {
                        console.log("after document", res)
                        this.stateService.documentsUpdate(true)
                        
                         let _refresh={
							type: "document",
							dossier: this.dossier,
							data:document
						};
	                   
	                    this.onActionClosed.emit(_refresh)
                    })
            }
        })

    }
    CheckDroitsApplication(type: any, element: any, action: any): boolean {
        let response = true
        let selectedDroit
        if (this.droits && this.droits.length > 0 && element) {
            this.droits.forEach((droit) => {
                droit.acces.forEach((acces) => {
                    if (
                        acces.instruction &&
                        element === acces.instruction.key &&
                        !acces.demande_type &&
                        !acces.instruction_etat
                    ) {
                        selectedDroit = acces
                    }
                })
            })
        }
        if (
            type === "instruction" &&
            selectedDroit &&
            selectedDroit.instruction
        ) {
            if (
                !selectedDroit.demande_type &&
                !selectedDroit.instruction_etat &&
                !selectedDroit.form &&
                !selectedDroit.document &&
                !selectedDroit.courrier &&
                selectedDroit.instruction.key === element
            )
                response = selectedDroit[action]
            if (action === "u" && !_.isEmpty(this.dossier)) {
            }
        }
        return response
    }

    CheckDroitsUser(): boolean {
        let response = true
        if (this.userDroits && this.userDroits.length > 0) {
            Object.keys(this.userDroits[0]).forEach((userDroitIndex) => {
                if (
                    this.router.url.toUpperCase().indexOf(userDroitIndex) !== -1
                ) {
                    response = this.userDroits[0][userDroitIndex].w
                }
            })
        }
        return response
    }
    optionsIfNotEmpty(button: any) {
        return button.parametre.options ? button.parametre.options : ""
    }
    handelAction(pages: any, routeConfig: any, _params:any) {
        let grpButton=[];
        let grpWithoutButton=[];
        pages.forEach((page) => {
          // console.log('page url action', page.url, routeConfig)
            if (page.url === routeConfig) {
                  console.log('page ', page)
                
               /*
                grpButton["PRINCIPAL"]={
                    libelle:"Principal",
                    children:[]
                };
                */
                page.actions.forEach((action: any) => {
					 if (action.rights.r) {
		                   //  console.log("action",action.tiers_type,routeConfig,_params)
		                   if (action.sous_groupe) {
		                      
		                       if (grpButton[action.sous_groupe.key]==undefined)
		                           grpButton[action.sous_groupe.key]={
		                                        libelle:  action.sous_groupe.libelle,
		                                        children:[],
		                                        link: 'etats'
		                                    };
		                   } 
	                   }
                });     
                
                page.actions.forEach((action: any) => {
                    let button = action
                    if (action.rights.r) {
	                     if (this.checkToAddButton(action.tiers_type,_params,button)) {   
	                         if (button.sous_groupe &&
	                            grpButton[button.sous_groupe.key]!=undefined) {
	                            grpButton[button.sous_groupe.key].children.push(button)
	                       } else
	                            grpWithoutButton.push(button)
	                   }     
                   }
                })
            }
        })
        
       // console.log("subheader grpButton",grpButton,grpWithoutButton )
        this.quickmenu=grpWithoutButton;
        
       Object.values(grpButton).forEach((value: any) => {
          //console.log("grpButton",value);
          this.quickmenu.push(value);    
        });
       // console.log("subheader quickmenu",this.quickmenu);
        
    }
    
    action(button:any,dos:any) {
		console.log("QuicMenu click",button,dos);
		if (button.parametre) {
                        switch (button.parametre.action) {
	                        case "link":
	                        	
                                  
                                  this.router.navigate(["/home/" + button.parametre.url]); 
                                
	                            
	                        	break
                            case "createForm":
                                 this.getFormulaire(button, this.optionsIfNotEmpty(button));
                                
                                break;

                            case "createCourrier":
								this.getChoiceCourrier(button.parametre.type, this.optionsIfNotEmpty(button))
                               
                                break

                            case "addDocument":
                              this.getDocument(button.parametre.type,   this.optionsIfNotEmpty(button));
								
                                break
                            case "createFoyer":
                               /* button.action = () => {
                                    return this.creationFoyer(
                                        button.parametre.type,
                                        this.optionsIfNotEmpty(button)
                                    )
                                }*/
                                break
                            case "addToFoyer":
                               /* button.action = () => {
                                    return this.addToFoyer(
                                        button.parametre.type,
                                        this.optionsIfNotEmpty(button)
                                    )
                                }*/
                                break
                            case "createSuivi":
                               /* button.action = () => {
                                    return this.creationSuivi(
                                        button.parametre.type,
                                        this.optionsIfNotEmpty(button)
                                    )
                                }*/
                                break
                            case "createVisite":
                              
                                    this.creationVisite(
                                        button.parametre.type,
                                        this.optionsIfNotEmpty(button),
                                        ''
                                    )
                                
                                break
                            case "createConsultation":
                              this.creationConsultation(
                                        button.parametre.type,
                                        this.optionsIfNotEmpty(button),
                                        '')
                                break
                            case "createInstruction":
                               this.createInstruction(
                                        button.parametre.type,
                                        button.parametre.instruction,
                                        this.optionsIfNotEmpty(button),
                                        ''
                                    )
                                
                                break       

                        }
                } else {
                       // console.log(button)
              		this.getFormulaire(button, '');
		}
	}
    
    checkToAddButton(tiers_type:any[],_params:any,button:any) {
        let added:boolean=true;
        if (_params.type!=undefined && tiers_type.length>0 ) {
            added=false;
            for(let i=0;i<tiers_type.length;i++) {
                if (tiers_type[i].type !=undefined
                  && tiers_type[i].type.code !=undefined
                 && tiers_type[i].type.code===_params.type)
                   added=true;
            }
           // console.log("checkToAddButton",added,tiers_type,_params.type,button)
        }
        return added;
        
    }

    getFormulaires(): any {
        this.formulaireService.list({ dossierId: this.dossier }).subscribe((formulaires: JSONRpcResponse) => {
            this.formulaires = formulaires.result

        })
    }
    getFoyer(type: any, page: any) {
        this.dialogService.open(FoyerActionsDialog, {
            data: {
                action: "create",
                dataType: "foyer",
                code: type,
                dossier: this.dossier,
            },
            height: "90vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
    }
    addToFoyer(type: any, page: any) {

        this.dialogService.open(FoyerActionsDialog, {
            data: {
                action: "add",
                dataType: "foyer",
                code: type,
                dossier: this.dossier,
            },
            height: "90vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
    }
    creationSuivi(type: any, page: any) {
        this.dialogService.open(SuiviActionsDialog, {
            data: {
                action: "create",
                dataType: "suivi",
                code: type,
                dossier: this.dossier,
                title: "Création d'une intervention",
            },
            height: "90vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result: any) => {
            this.stateService.updateRefresh(true)
        })
    }
    creationVisite(type: any, page: any, pageUrl: any) {
        this.dialogService.open(VisiteActionsDialog, {
            data: {
                action: "create",
                dataType: "rdv",
                code: type,
                dossier: this.dossier,
                title: "Création d'un rendez-vous",
                create: true,
            },
            height: "95vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (res: any) => {
                   console.log(res)
                
                    let _refresh={
						type: "visite",
						dossier: this.dossier,
						data:res
					};
                   
                   this.onActionClosed.emit(_refresh)
                    
                    
           })

    }
    
    loadConsultationType() {
       
    }
    
    
    
    
    creationConsultation(type: any, page: any, pageUrl: any) {
        
        
        
        
         this.consultationService.getConsultationTypeList().subscribe((res: JSONRpcResponse) => {
            
            let dataCs={
                action: "create",
                dataType: "consultation",
                code: type,
                dossier: this.dossier,
                title: "Création d'une séance",
                create: true,
                types:res.result
            }
            
           this.dialogService.open(CreateConsultationDialogComponent, {
                    data: dataCs,
                    height: "90vh",
		            width: "80vw",
                    draggable: true,
                    maximizable: true,
                    minimizable: true,
                    resizable: true,
                }, (res: any) => {
                   console.log(res)
                   
	                    let _refresh={
							type: "consultation",
							dossier: this.dossier,
							data:dataCs
						};
	                   
	               this.onActionClosed.emit(_refresh)
                })
            this.cdf.detectChanges()
        })
        
       
        

    }
    
    createInstruction(type: any,instruction:any, page: any, pageUrl: any): void {
        let dataIns={
             action: "create",
            dataType: "consultation",
            code: type,
            dossier: this.dossier,
            title: "Création d'une procédure",
            create: true,
            instruction_type: instruction
            }
         console.log("createInstruction",dataIns)
        this.dialogService.open(InstructionActionsDialog, {
                    data: dataIns,
                    width: '50vw',
                    draggable: true,
                    maximizable: true,
                    minimizable: true,
                    resizable: true,
                }, (res: any) => {
                    console.log(res)
                    if (res) {
	                    let _refresh={
							type: "instruction",
							dossier: this.dossier,
							data:dataIns
						};
	                   
	                    this.onActionClosed.emit(_refresh)
                    }
                    
           })
    }
    
    
}
